import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { config } from '../../config';
import { UserContext } from '../../context/UserContext';
import InputMask from 'react-input-mask';
import styles from './GerenciarCadastros.module.css';
import { useNavigate, useLocation } from 'react-router-dom';

function GerenciarCadastros() {
    const { codigoCondominio } = useContext(UserContext);
    const [cadastros, setCadastros] = useState([]);
    const [filteredCadastros, setFilteredCadastros] = useState([]);
    const [nomeCompleto, setNomeCompleto] = useState('');
    const [CPF, setCPF] = useState('');
    const [bloco, setBloco] = useState('');
    const [unidade, setUnidade] = useState('');
    const [inativosOnly, setInativosOnly] = useState(false);
    const [expandedIndex, setExpandedIndex] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();

    const removerAcentos = (str) => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    // Busca os cadastros do backend
    useEffect(() => {
        if (codigoCondominio) {
            axios.get(`${config.apiBaseUrl}/Cliente/listar/${codigoCondominio}`)
                .then((response) => {
                    setCadastros(response.data);
                    setFilteredCadastros(response.data);
                })
                .catch((error) => {
                    console.error('Erro ao buscar cadastros:', error);
                });
        }
    }, [codigoCondominio]);

    // Aplica automaticamente o filtro de inativos caso venha da Home
    useEffect(() => {
        if (location.state && location.state.filtroInativos) {
            setInativosOnly(true);
        }
    }, [location.state]);

    // Filtra os cadastros automaticamente ao alterar qualquer campo
    useEffect(() => {
        const normalizeCPF = (cpf) => cpf.replace(/[^\d]/g, ''); // Remove qualquer caractere que não seja número

        const filtered = cadastros.filter((cadastro) => {
            const cadastroCPF = normalizeCPF(cadastro.nR_CPF || ''); // Remove a máscara do CPF armazenado
            const inputCPF = normalizeCPF(CPF); // Remove a máscara do CPF digitado

            return (
                (nomeCompleto === '' ||
                    (cadastro.nM_CLI &&
                        removerAcentos(cadastro.nM_CLI.toLowerCase()).includes(removerAcentos(nomeCompleto.toLowerCase())))) &&
                (CPF === '' || cadastroCPF.includes(inputCPF)) && // Busca parcial pelo CPF
                (bloco === '' || (cadastro.blC_CLI && cadastro.blC_CLI.toLowerCase().includes(bloco.toLowerCase()))) &&
                (unidade === '' || cadastro.nR_UND.toString().includes(unidade)) && // Busca parcial pela unidade
                (!inativosOnly || cadastro.sT_CLI === false)
            );
        });

        setFilteredCadastros(filtered);
    }, [nomeCompleto, CPF, bloco, unidade, inativosOnly, cadastros]);


    const handleExpand = (index) => {
        setExpandedIndex(index === expandedIndex ? null : index);
    };

    const handleEdit = (cadastro) => {
        navigate(`/usuario/gerenciar-cadastros/editar/${cadastro.cD_CLI}`, { state: { cadastro } });
    };

    return (
        <div className={styles.gerenciarContainer}>
            {/* Filtros */}
            <div className={styles.filterContainerCadastro}>
                <div className={styles.formRowCadastro}>
                    <label className={styles.labelCadastro}>
                        Nome:
                        <input
                            type="text"
                            value={nomeCompleto}
                            onChange={(e) => setNomeCompleto(e.target.value)}
                            className={styles.inputField}
                        />
                    </label>
                    <label className={styles.labelCadastro}>
                        CPF:
                        <InputMask
                            mask="999.999.999-99"
                            value={CPF}
                            onChange={(e) => setCPF(e.target.value)}
                            className={styles.inputField}
                        />
                    </label>
                    <label className={styles.labelCadastro}>
                        Bloco:
                        <input
                            type="text"
                            value={bloco}
                            onChange={(e) => setBloco(e.target.value)}
                            className={styles.inputField}
                        />
                    </label>
                    <label className={styles.labelCadastro}>
                        Unidade:
                        <input
                            type="text"
                            value={unidade}
                            onChange={(e) => setUnidade(e.target.value)}
                            className={styles.inputField}
                        />
                    </label>
                    <label className={styles.labelCheckboxCadastro}>
                        <input
                            type="checkbox"
                            checked={inativosOnly}
                            onChange={(e) => setInativosOnly(e.target.checked)}
                            className={styles.checkboxFieldCadastro}
                        />
                        Mostrar apenas cadastros inativos
                    </label>
                </div>
            </div>

            {/* Lista de cadastros */}
            <div className={styles.cadastroList}>
                {filteredCadastros.map((cadastro, index) => (
                    <div
                        key={index}
                        className={`${styles.cadastroItem} ${cadastro.sT_CLI ? styles.cadastroAtivo : styles.cadastroInativo}`}
                        onClick={() => handleExpand(index)}
                    >
                        <div className={styles.blocoUnidade}>
                            <p><strong>Bloco:</strong> {cadastro.blC_CLI && cadastro.blC_CLI !== 'N/A' ? cadastro.blC_CLI : '-'}</p>
                            <p><strong>Unidade:</strong> {cadastro.nR_UND || '-'}</p>
                        </div>
                        <p><strong>Nome Completo:</strong> {cadastro.nM_CLI}</p>
                        {expandedIndex === index && (
                            <div className={styles.expandContent}>
                                <p><strong>CPF:</strong> {cadastro.nR_CPF}</p>
                                <p><strong>Email:</strong> {cadastro.email}</p>
                                <p><strong>Número do celular:</strong> {cadastro.fN_CLI}</p>
                                <button
                                    className={styles.editButton}
                                    onClick={() => handleEdit(cadastro)}
                                >
                                    Editar cadastro
                                </button>
                            </div>
                        )}
                    </div>
                ))}
                {filteredCadastros.length === 0 && (
                    <p className={styles.mensagemUser}>Nenhum cadastro encontrado.</p>
                )}
            </div>
        </div>
    );
}

export default GerenciarCadastros;
